import venueTypesSeedJson from './venueTypesSeed.json'

type TVenueTypeSlug = (typeof venueTypesSeedJson)[number]['slug']

/** Canonical venue type slugs (aligned with the Book venue type catalog). */
export const VENUE_TYPES = venueTypesSeedJson.map(row => row.slug) as [
  TVenueTypeSlug,
  ...TVenueTypeSlug[]
]

export type TVenueType = TVenueTypeSlug

const CATALOG_LABELS_EN: Record<string, string> = Object.fromEntries(
  venueTypesSeedJson.map(row => [row.slug, row.labels.en])
)

/** Pre-catalog values still stored on some tenant rows until DO migration runs. */
const LEGACY_VENUE_TYPE_LABELS: Record<string, string> = {
  hospitality: 'Hospitality',
  outdoor: 'Outdoor',
  mall: 'Retail'
}

/** English display label for a venue type slug (catalog or legacy). */
export function formatVenueTypeLabel(venueType: string | null | undefined): string | null {
  if (venueType == null || venueType === '') {
    return null
  }
  return CATALOG_LABELS_EN[venueType] ?? LEGACY_VENUE_TYPE_LABELS[venueType] ?? venueType
}

/** Maximum venue photos per venue in the management app. */
export const VENUE_MAX_PHOTOS = 5
